// extracted by mini-css-extract-plugin
export default {"heading":"St-z","corrected":"Tt-z","redirectVerbiageContainer":"Ut-z","redirectVerbiageText":"Vt-z"};